exports = module.exports = require("../../../css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TextFilter {\r\n\tdisplay: inline-block;\r\n\tbackground-color: white;\r\n\toverflow: visible;\r\n\tbox-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-moz-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n\t-webkit-box-shadow: 0px 1px 4px 0px rgba(0, 0, 0, 0.5);\r\n}\r\n\r\n.TextFilter > div {\r\n\tdisplay: -ms-flexbox;\r\n\tdisplay: flex;\r\n\t-ms-flex-align: stretch;\r\n\t    align-items: stretch;\r\n\toverflow: visible;\r\n}\r\n\r\n.TextFilter > div > .Input {\r\n\t-ms-flex: 1 1 0px;\r\n\t    flex: 1 1 0;\r\n\tmargin: 0;\r\n\tbackground-color: transparent;\r\n\tborder: 0;\r\n\tpadding-left: 15px;\r\n}\r\n\r\n.TextFilter > div > .Button {\r\n\t-ms-flex: 0 0 auto;\r\n\t    flex: 0 0 auto;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/vwa/components/TextFilter/TextFilter.css
// module id = 704
// module chunks = 0